import {IDropdownObject} from './dropdown-object.interface';

export interface IManagerColumns {
  columns: string[];
  employeeId: number | null;
  id: number | null;
}

export interface IListOfEmployee {
  addressOfActualResidence: string | null;
  ammountOfAttempts: number | null;
  assignedHr: string;
  dateOfJoining: string;
  departments: string;
  employeeValues: string;
  employmentForm: string;
  englishLevelGrammar: string;
  englishLevelSpeaking: string;
  gender: string;
  hasMentor: string;
  hobbies: string;
  hoodieClothesSize: string;
  id: number;
  isMentor: string;
  level: string;
  lineManager: string;
  location: string;
  mentor: string;
  nameSurname: string;
  os: string;
  position: string;
  postOfficeAddress: string;
  probationEndDate: string;
  probationStartDate: string;
  projectManager: string;
  role: string;
  securityTrainingResult: string;
  securityTrainingStatus: string;
  status: string;
  tShirtClothesSize: string;
  techStack: string;
  unit: string;
  workEmail: string;
}

export interface IFilterValidation {
  date: Date | string;
  setType: string;
}

export enum Tab {
  General = 'general',
  Hr = 'hrdata',
  Personal = 'personal',
  Professional = 'professional',
  PersonalRecruiter = 'personal-recruiter',
}

export enum EmploymentForm {
  Employee = 'Employee',
  Former = 'Former',
  ContractorPT = 'Contractor part-time',
  Consultant = 'Consultant',
}

export interface IEmployeeAccessData {
  employeeId: number;
  department: IDropdownObject;
  lineManagerId: number;
  position: IDropdownObject;
  isLineManager: boolean;
  unitId: number;
}

export interface IAccessData {
  userData: IEmployeeAccessData;
  employeeData: IEmployeeAccessData;
}
